import {Component, OnInit} from '@angular/core';
import {CrudService} from "@core/shared/services/crud.service";
import {CrudAction} from "@core/shared/models/crud";

@Component({
    selector: 'app-page-offer-update',
    templateUrl: './page-offer-attribute-update.component.html',
    styleUrls: ['./page-offer-attribute-update.component.scss'],
    providers: [
        CrudService
    ],
    standalone: false
})
export class PageOfferAttributeUpdateComponent implements OnInit {

    constructor(
        private _crudService: CrudService
    ) {
    }

    ngOnInit() {

        this._crudService.setAction(CrudAction.Update);
    }
}
